import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuspayReportingService } from 'src/app/core/services/focuspay-reporting.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { DatacapBatchRecord } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';

@Component({
	selector: 'app-batch-record',
	templateUrl: './batch-record.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class BatchRecordComponent implements OnInit {
	batchRecord: DatacapBatchRecord;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public focusPayReportingService: FocuspayReportingService,
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		console.log('nginit');
		const batchNumber = +this.activatedRoute.snapshot.paramMap.get('batchNumber');
		console.log(batchNumber);
		this.batchRecord = this.focusPayReportingService.batchRecords.value.find((batchRecord) => batchRecord.number === batchNumber);
		console.log(this.batchRecord);
	}

	back() {
		this.router.navigate(['/cc/credit/dashboard']);
	}
}
